/**
 * @fileoverview User directory summary query hook.
 * @description Wraps GET /users/summary, the User Management KPI cards.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { useQuery } from '@tanstack/react-query'

import { USERS_QUERY_KEYS } from '@/features/users/constants/users-query-keys.constants'
import { getUsersSummary } from '@/features/users/services/users.service'

import type { UsersSummary } from '@/features/users/types/users.types'
import type { ApiError } from '@/shared/types/http.types'

/**
 * @description Fetches the directory's counts by Sales position.
 * @returns {import('@tanstack/react-query').UseQueryResult<UsersSummary, ApiError>} The query
 * result.
 */
export function useUsersSummary() {
  return useQuery<UsersSummary, ApiError>({
    queryKey: USERS_QUERY_KEYS.summary,
    queryFn: getUsersSummary,
  })
}
